import React, { Component } from 'react'
import EditCustomer from './EditCustomer/EditCustomer';
import CreateTowInvoice from '../components/Invoice/CreateTowInvoice';
import CreateShopInvoice from '../components/Invoice/CreateShopInvoice';
import CreateLoadInvoice from '../components/Invoice/CreateLoadInvoice';
import {LoadInvoicesForCustomer,
        ShopInvoicesForCustomer,
        TowInvoicesForCustomer} from '../components/Invoice/InvoicesForCustomer';
import InvoicePreviewPage  from '../components/Invoice/InvoicePreviewPage'
import CustomerService from '../services/WebCustomerService';
import { Switch, Route } from 'react-router-dom';
import EditInvoice from '../components/Invoice/EditInvoice';
import config from '../clientConfig';
import themeService from '../themes/themeService';
import CustomerActivityAppBar from './CustomerActivityAppBar';
import { InvoiceType } from 'common/constants';

const { palette } = themeService.getTheme();

const styles = {
    tabs: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-around'
    },
    h2: {
        color: palette.secondary.main
    },
    pageContent: {
        margin: '1rem'
    }
}

const tabs = {
    'customerInfo': 0,
    'viewInvoices': 1,
    'viewShopInvoices': 2,
    'createInvoice': 3,
    'createShopInvoice':4
};


function AppBarRoute(props) {
    return <Route path={props.path}                                
                  render={ (passedProps) => <CustomerActivityAppBar {...passedProps} {...props}/>}/>
}

class CustomerActivityPage extends Component {

    constructor(props) {
        super(props);
        this.state = {            
            customer: null,            
            value: tabs.customerInfo
        }
    }

    componentWillMount() {    
        let customerId  = this.props.match.params.customerId;
                  
        if(!isNaN(customerId)) {            
            CustomerService.getCustomer(customerId, (data) => {
                this.setState({ customer: data.results });  
            });
        }    
    }
    
    render() {
        let customer = this.state.customer;
        if(customer) {
            return (
                <div style={styles.pageContent} className="page-content">
                    <h2 style={styles.h2}>{customer.name}</h2> 
                    <Switch>                    
                        <AppBarRoute 
                            path='/customer/:customerId/edit' 
                            Component={EditCustomer} 
                            tab={'customerInfo'}/>
                        <AppBarRoute 
                            path='/customer/:customerId/invoices' 
                            Component={TowInvoicesForCustomer} 
                            tab={'viewInvoices'}/>
                        {!config.isPetroff ? 
                            <AppBarRoute 
                                path='/customer/:customerId/shopinvoices' 
                                Component={ShopInvoicesForCustomer} 
                                customerId={customer.id} 
                                tab={'viewShopInvoices'}/> : <AppBarRoute
                                path='/customer/:customerId/loadInvoices' 
                                Component={LoadInvoicesForCustomer}
                                customerId={customer.id}
                                tab={'viewLoadInvoices'}/> }
                        <AppBarRoute 
                            path='/customer/:customerId/invoice/:invoiceId'                            
                            invoiceType={InvoiceType.TOW}
                            tab={'viewInvoices'}
                            Component={InvoicePreviewPage}/>
                        {!config.isPetroff ? 
                            <AppBarRoute 
                                path='/customer/:customerId/shopinvoice/:invoiceId'
                                customerId={customer.id}
                                invoiceType={InvoiceType.SHOP}
                                Component={InvoicePreviewPage}
                                tab={'viewShopInvoices'}/>
                            : <AppBarRoute
                                path='/customer/:customerId/loadinvoice/:invoiceId'
                                customerId={customer.id}
                                invoiceType={InvoiceType.LOAD}
                                Component={InvoicePreviewPage} 
                                tab={'viewLoadInvoices'}/> }
                        <AppBarRoute 
                            path='/customer/:customerId/createinvoice' 
                            customerId={customer.id}                            
                            Component={CreateTowInvoice}
                            tab={'createInvoice'}
                            />
                        <AppBarRoute 
                            path='/customer/:customerId/createshopinvoice' 
                            customerId={customer.id}
                            Component={CreateShopInvoice} tab={'createShopInvoice'}/>
                        <AppBarRoute 
                            path='/customer/:customerId/createloadinvoice' 
                            customerId={customer.id}
                            Component={CreateLoadInvoice} tab={'createLoadInvoice'}/>
                        <AppBarRoute 
                            path='/customer/:customerId/editInvoice/:invoiceId'                             
                            invoiceType={InvoiceType.TOW}
                            customerId={customer.id}
                            tab={'viewInvoices'} 
                            Component={EditInvoice}/>
                        <AppBarRoute 
                            path='/customer/:customerId/editLoadInvoice/:invoiceId'
                            invoiceType={InvoiceType.LOAD}
                            customerId={customer.id}
                            tab={'viewLoadInvoices'}
                            Component={EditInvoice}/>
                        <AppBarRoute 
                            path='/customer/:customerId/editShopInvoice/:invoiceId'
                            invoiceType={InvoiceType.SHOP}
                            tab={'viewShopInvoices'} 
                            Component={EditInvoice}
                        />
                               
                    </Switch>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default CustomerActivityPage
